<script lang="ts" setup>
import IdecoProductLpTemplate from '~/components/templates/ProductLpTemplate/ideco/IdecoProductLpTemplate.vue';
</script>

<template>
  <IdecoProductLpTemplate />
</template>

<style lang="scss" module></style>
